import * as React from 'react';
import { memo, useEffect } from 'react';
import { CheckoutOrderFragment } from '@websky/graphql';
import { useFareLock, useRefundOption } from '../../../ConfirmOption/hooks';
import ConfirmOption from '../../../ConfirmOption';

interface Props {
	order: CheckoutOrderFragment;
	handleOrderLoaded: (order: CheckoutOrderFragment) => void;
	onLoadingChange: (isLoading: boolean) => void;
}

const ConfirmOptions: React.FC<Props> = memo(({ order, handleOrderLoaded, onLoadingChange }) => {
	const {
		price: fareLockPrice,
		handleChange: fareLockHandleChange,
		isSelected: isFareLockSelected,
		optionService: fareLockService,
		loading: fareLockServiceLoading
	} = useFareLock(order, handleOrderLoaded);

	const {
		price: refundOptionPrice,
		handleChange: refundOptionHandleChange,
		isSelected: isRefundOptionSelected,
		optionService: refundOptionService,
		loading: refundOptionServiceLoading
	} = useRefundOption(order, handleOrderLoaded);

	const isLoading = fareLockServiceLoading || refundOptionServiceLoading;

	useEffect(() => {
		onLoadingChange(isLoading);
	}, [isLoading]);

	return (
		<>
			{refundOptionService && (
				<ConfirmOption
					variant="Refund"
					price={refundOptionPrice}
					isActive={isRefundOptionSelected}
					isDisabled={!isLoading && isFareLockSelected}
					onChange={refundOptionHandleChange}
					isLoading={isLoading}
				/>
			)}

			{fareLockService && (
				<ConfirmOption
					variant="FareLock"
					freezeUntil={fareLockService.freezeUntil}
					price={fareLockPrice}
					isActive={isFareLockSelected}
					isDisabled={!isLoading && isRefundOptionSelected}
					onChange={fareLockHandleChange}
					isLoading={isLoading}
				/>
			)}
		</>
	);
});

export default ConfirmOptions;
